import { EditorConfigService } from './../../../../shared/services/angular-editor.service';
import { FAQCategoryService } from './../../../../shared/services/faq-category.service';
import { FAQService } from './../../../../shared/services/faq.service';
import { ToastrService } from 'ngx-toastr';
import { IFAQ, IFAQCategory } from '../../../../_models/cms/IFAQ';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-faq-form',
  templateUrl: './faq-form.component.html'
})
export class FAQFormComponent implements OnInit {

  public mask = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  loading: boolean;
  title: string = 'Add FAQ';
  faq: IFAQ;
  faqForm: FormGroup;
  faqCategories: IFAQCategory[];
  id;

  editorConfigOption: AngularEditorConfig;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private toastrService: ToastrService,
              private service: FAQService,
              private faqCategoryService: FAQCategoryService,
              private editorConfigService: EditorConfigService) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.editorConfigOption = editorConfigService.getOption();
  }

  ngOnInit() {
    this.createFAQForm();
    this.bindDropDown();
    if (this.id) this.service.get(this.id).subscribe((response: IFAQ) => {
      if (response) {
        this.faq = response;
        this.title = 'Edit FAQ';
        this.setValueFAQForm();
      }
    });
  }

  bindDropDown() {
    this.faqCategoryService.getAllFAQCategories().subscribe((response: IFAQCategory[]) => {
      if (response) {
        this.faqCategories = response;
      }
    });
  }

  createFAQForm() {
    this.faqForm = this.fb.group({
      id: ['0', Validators.required],
      question: ['', Validators.required],
      answer: ['', Validators.required],
      faqCategoryId: ['', Validators.required],
    });
  }

  setValueFAQForm() {
    this.faqForm.patchValue({
      id: this.faq.id,
      question: this.faq.question,
      answer: this.faq.answer,
      faqCategoryId: this.faq.faqCategoryId,
    });
  }

  save() {
    if (this.faqForm.valid) {
      this.loading = true;
      this.faq = Object.assign({}, this.faqForm.value);
      if (this.id) {
        this.service.update(this.id, this.faq).subscribe(() => {
          this.toastrService.success('FAQ updated successful');
          this.router.navigate(['/admin/faqs']);
        },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
      }
      else {
        this.service.create(this.faq).subscribe(() => {
          this.toastrService.success('FAQ created successful');
          this.router.navigate(['/admin/faqs']);
        },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
      }
    }
  }

  delete() {
    if (!confirm('Are you sure you want to delete this FAQ?')) return;

    this.service.delete(this.id).subscribe(() => {
      this.toastrService.success('FAQ deleted successful');
      this.router.navigate(['/admin/faqs']);
    });
  }

}
